import ContentBody from '@op/components/ContentBody';
import React, { useMemo, useRef } from 'react';
import { Layout } from 'tea-component';
import { connect, getLocale, useHistory, useIntl, useParams } from 'umi';
import { usePageInfoValue } from '../../hooks';
import CardLoading from '@op/components/CardLoading';
import PreviewBody, { InsightPreviewBody } from './PreviewBody';
import './index.scss';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { AIPreview } from '@op/operationLog/pages';
import { LANGUAGE_EN } from '@op/_config/config';
import {
  DEFAULT_REPORT_OWNER,
  type TReportOwner,
} from '@op/components/ReportPermission';

const { Content } = Layout;
const PreviewSummary = (props: any) => {
  const { gameInfo, wholeGameInfo } = props;
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const { isSubscript, redirect, owner } = history.location?.query || {};
  const isCommon = useRef(isSubscript === 'false');
  const contentRef = useRef<HTMLDivElement | null>(null);
  const { formatMessage } = useIntl();
  const {
    loading,
    pageName: pageNameEN,
    pageNameCN,
    shortId,
    promptInfo,
    reportItem,
  } = usePageInfoValue({
    id,
    gameInfo,
    isSubscript: !isCommon.current,
  });

  useInitBuriedPointInfo({
    buriedPoint: AIPreview,
    pageExtInfo: 'CustomAISummary'
  });

  const backURL = useMemo(() => {
    if (redirect) {
      return redirect;
    }
    const listTab = isSubscript === 'true' ? 'subscriptions' : 'oneTime';
    const ownerUrl =
      owner && owner !== DEFAULT_REPORT_OWNER
        ? `&owner=${owner as TReportOwner}`
        : '';
    return `/opinion/AIAnalysisHub/CustomAISummary?gameid=${gameInfo?.edition_unified_id}&tab=summary&listTab=${listTab}${ownerUrl}`;
  }, [isSubscript, gameInfo, redirect, owner]);

  const pageName = useMemo(
    () => (getLocale() === LANGUAGE_EN ? pageNameEN : pageNameCN),
    [pageNameEN, pageNameCN, formatMessage],
  );

  return (
    <Content className="dbo-page dbo-page-preview-summary" ref={contentRef}>
      <ContentBody
        contentHeard={
          <Content.Header
            showBackButton
            onBackButtonClick={() => history.push(backURL)}
            title={pageName}
          ></Content.Header>
        }
      >
        <CardLoading loading={loading}>
          {isCommon.current ? (
            <PreviewBody
              wholeGameInfo={wholeGameInfo}
              gameInfo={gameInfo}
              shortId={shortId}
              contentRef={contentRef}
              promptInfo={promptInfo}
            />
          ) : (
            <InsightPreviewBody
              wholeGameInfo={wholeGameInfo}
              gameInfo={gameInfo}
              shortId={shortId}
              reportItem={reportItem}
              contentRef={contentRef}
              promptInfo={promptInfo}
            ></InsightPreviewBody>
          )}
        </CardLoading>
      </ContentBody>
    </Content>
  );
};

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(PreviewSummary);
